import axios from "axios";
import { reactive, ref } from "vue";
import { loading, errors, toast, meta, loadingBtn, remove,directLoading } from "./shared";

export default function useOpportunity(navigation) {
  const { route, router } = navigation;
  const opportunities = ref([]);
  const opportunity = reactive({
    attachments: [],
    items: [],
  });
  const getOpportunities = async (query = {}) => {
    try {
      errors.value = "";
      loading.value = true;
      const saerch = isObjectNotEmpty(query)
        ? "?" + new URLSearchParams(query).toString()
        : "";
      let response = await axios.get("user/opportunity" + saerch);
      loading.value = false;
      opportunities.value = response.data.data;
      Object.assign(meta, response.data.meta);
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

   const getOpportunitiesFromRoute = async (id,query = {}) => {
    try {
      errors.value = "";
      directLoading.value = true;
      const saerch = isObjectNotEmpty(query)
        ? "?" + new URLSearchParams(query).toString()
        : "";
      let response = await axios.get("user/route/"+id+"/opportunity" + saerch);
      directLoading.value = false;
      if(query.page > 1)opportunities.value.push(...response.data.data);
      else opportunities.value = response.data.data;
      Object.assign(meta, response.data.meta);
    } catch (e) {
      errors.value = e;
      directLoading.value = false;
    }
  };

  const getOpportunity = async (id) => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get("user/opportunity/" + id);
      loading.value = false;
      Object.assign(opportunity, response.data.data);
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  const addOpportunity = async () => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get("user/opportunity/create");
      loading.value = false;
      Object.assign(meta, { ...response.data });
      Object.assign(opportunity,{currency: meta.currency_types[0]});
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  const editOpportunity = async () => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get(
        "user/opportunity/" + opportunity.id + "/edit"
      );
      loading.value = false;
      Object.assign(opportunity, response.data.data);
      Object.assign(meta, { ...response.data });
      if(opportunity.person)Object.assign(meta,{['person'] : [opportunity.person]});
      if(opportunity.account)Object.assign(meta,{['account'] : [opportunity.account]});
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  const storeOpportunity = async (modal = null) => {
    try {
      errors.value = "";
      progressDialog.value = true;
      let response = await axios.post("user/opportunity", opportunity);
      progressDialog.value = false;
      toast.success(response.data.message);
      if(modal) document.getElementById(modal).checked = false;
      else router.push({ name: "user.opportunities" });
    } catch (e) {
      window.networkError(e);
      progressDialog.value = false;
    }
  };

  const updateOpportunity = async (modal = null) => {
    try {
      errors.value = "";
      progressDialog.value = true;
      let response = await axios.put(
        "user/opportunity/" + opportunity.id,
        opportunity
      );
      progressDialog.value = false;
      toast.success(response.data.message);
      if(modal) document.getElementById(modal).checked = false;
      else if (history.state.back) router.back();
      else router.push({ name: "user.opportunities" });
    } catch (e) {
      window.networkError(e);
      progressDialog.value = false;
    }
  };

  const removeOpportunity = async (modal = false) => {
    try {
      loadingBtn.value = true;
      let response = await axios.delete("user/opportunity/" + remove.id);
      toast.success(response.data.message);
      loadingBtn.value = false;
      document.getElementById("opportunity-delete-modal").checked = false;
      if (remove.single) {
        if (history.state.back) router.back();
        else router.push({ name: "user.opportunities" });
      } else if(!modal) getOpportunities(route.query);
      remove.single = false;
      return response.data;
    } catch (e) {
      window.networkError(e);
      loadingBtn.value = false;
    }
  };

  return {
    opportunities,
    opportunity,
    getOpportunities,
    getOpportunitiesFromRoute,
    getOpportunity,
    addOpportunity,
    editOpportunity,
    storeOpportunity,
    updateOpportunity,
    removeOpportunity,
  };
}
